import { render, staticRenderFns } from "./AddBarTrendTDWidget.vue?vue&type=template&id=33cd6f92"
import script from "./AddBarTrendTDWidget.vue?vue&type=script&lang=js"
export * from "./AddBarTrendTDWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports